/* unplugin-vue-components disabled */import script from "./largeScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./largeScreen.vue?vue&type=script&lang=ts&setup=true"

import "./largeScreen.vue?vue&type=style&index=0&id=103198a8&scoped=true&lang=scss"

import exportComponent from "/Users/shenhao/workDocument/idea/IDEACode/YKWebCode/shaoguanFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103198a8"]])

export default __exports__